import { component, getter, action } from '../../decorators';

import WbHeader from '../header/header.vue';
import Paginator from '../../components/common/paginator/paginator.vue';
import CircleProgressbar from '../../components/common/circle-progressbar/circle-progressbar.vue';

import { REMOVE_CART, CHECKOUT_CART, CHANGE_CART_PAGE } from '../../store/actions';

import ComponentCreator from '../../helpers/component.creator';
import scrollIntoViewIfNeeded from '../../helpers/dom/scrollIntoViewIfNeeded';

import { CARTS_PAGE_SIZE as PAGE_SIZE } from '../../config';

import l10n from '../../transformers/l10n';

const STATUSES_NAME = {
   ready: 'ready for download'
};

@component({
   name: 'Carts',
   components: { WbHeader, Paginator, CircleProgressbar },
   watch: {
      page: 'onPageChanged'
   }
})
export default class Carts {
   @getter('getCartsForCurrentPage') carts
   @getter('getCartPageCount') pages
   @getter('getCurrentCartPage') page
   @getter('getCurrentUser') currentUser

   /** @type {Function} */
   @action(REMOVE_CART) removeCart

   /** @type {Function} */
   @action(CHECKOUT_CART) checkout

   /** @type {Function} */
   @action(CHANGE_CART_PAGE) changePage

   get offset() {
      return PAGE_SIZE * this.page;
   }

   get deleteTitle() {
      return l10n('cart.delete');
   }

   async remove(cart) {
      const message = l10n('cart.confirm_remove', { name: cart.name });
      if (await ComponentCreator.confirm(message)) {
         this.removeCart(cart);
      }
   }

   gotoCart({ id }) {
      const params = { cid: id };
      this.$router.push({ name: 'CartInfo', params });
   }

   onPageChanged() {
      scrollIntoViewIfNeeded(this.$refs.title);
   }

   shareByTitle(cart) {
      if (cart.userName !== this.currentUser.userName) {
         return l10n('cart.sharing.sharedby', { owner: cart.ownerName });
      }

      return l10n('cart.sharing.youowner');
   }
}
